<template>
  <div class="yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]">
    <!-- 导航栏 -->
    <navBar :title="$t('badges.title')"></navBar>

    <!-- 等级升级卡片 -->
    <div class="mx-4 mt-3 bg-white rounded-2xl p-6 shadow-sm border border-gray-200" v-if="cur.level !== 5">
      <!-- 上方：图标和数字 -->
      <div class="flex items-start justify-between gap-4 mb-4">
        <!-- 当前等级 -->
        <div class="flex flex-col items-center flex-1">
          <div class="w-24 h-24 rounded-full flex items-center justify-center">
            <img :src="imageBaseUrl + cur.icon" alt="cur" class="w-full h-full object-cover" />
          </div>
          <div class="text-xl font-bold text-gray-800">{{ curPoint }}</div>
          <div class="text-red-600 text-lg">▲</div>
        </div>

        <!-- 升级箭头（虚线 + 三角 + 文字） -->
        <div class="flex flex-col items-center flex-1 justify-start pt-10">
          <div class="flex items-center gap-1 mb-2">
            <span class="w-2 h-1 bg-orange-500 rounded-full"></span>
            <span class="w-2 h-1 bg-orange-500 rounded-full"></span>
            <span class="w-2 h-1 bg-orange-500 rounded-full"></span>
            <span class="w-2 h-1 bg-orange-500 rounded-full"></span>
            <span class="w-2 h-1 bg-orange-500 rounded-full"></span>
            <span class="text-orange-500 text-sm">▶</span>
          </div>
          <div class="text-xs text-gray-600 text-center mt-6">
            {{ $t("badges.needPoints") }} {{ diffPoint  }}
            <br />
            {{ $t("badges.canUpgrade") }}
          </div>
        </div>

        <!-- 下一等级 -->
        <div class="flex flex-col items-center flex-1">
          <div class="w-24 h-24 rounded-full flex items-center justify-center">
            <img :src="imageBaseUrl + next.icon" alt="next" class="w-full h-full object-cover" />
          </div>
          <div class="text-xl font-bold text-gray-800">{{ next.point }}</div>
          <div class="text-red-600 text-lg">▲</div>
        </div>
      </div>

      <!-- 下方：等级名称和三角形 -->
      <div class="flex items-end justify-between gap-4">
        <!-- 当前等级名称 -->
        <div class="flex flex-col items-center flex-1">
          <div class="text-xs text-gray-600 text-center ">{{ $t("badges.currentLevel") }}: </div>
          <div class="text-xs text-gray-600 text-center mb-2">{{ isZh ? cur.name : cur.nameEn }}</div>
        </div>
        <!-- 中间空白 -->
        <div class="flex-1"></div>
        <!-- 下一等级名称 -->
        <div class="flex flex-col items-center flex-1">
          <div class="text-xs text-gray-600 text-center">{{ $t("badges.nextLevel") }}:</div>
          <div class="text-xs text-gray-600 text-center mb-2">{{ isZh ? next.name : next.nameEn }}</div>
        </div>
      </div>
    </div>

    <div class="mx-4 mt-3 bg-white rounded-2xl p-6 shadow-sm border border-gray-200" v-if="cur.level === 5">
      <!-- 上方：图标和数字 -->
      <div class="flex items-start justify-between gap-4 mb-4">
        <!-- 当前等级 -->
        <div class="flex flex-col items-center flex-1">
          <div class="w-24 h-24 rounded-full flex items-center justify-center">
            <img :src="imageBaseUrl + cur.icon" alt="cur" class="w-full h-full object-cover" />
          </div>
          <div class="text-xl font-bold text-gray-800">{{ curPoint }}</div>
          <div class="text-red-600 text-lg">▲</div>
          <div class="text-xs text-gray-600 text-center mt-2">{{ $t("badges.currentLevel") }}: {{ cur.name }}</div>
        </div>
      </div>
    </div>

    <!-- 权益对比表 -->
    <!-- <div class="mx-1 mt-7 mb-6">
      <div class="bg-white rounded-xl overflow-hidden shadow-sm">
        <div
          class="grid gap-0 border-b border-gray-200 bg-gray-100 items-end"
          :style="{ gridTemplateColumns: `1fr repeat(${badges.length}, 1fr)` }">
          <div class="px-1 py-2 text-xs font-bold text-gray-800">{{ $t("badges.benefit") }}</div>
          <div
            v-for="(badge, index) in badges"
            :key="'header-' + index"
            class="px-1 py-2 text-xs font-bold text-gray-800 text-center flex flex-col items-center justify-between">
            <img :src="imageBaseUrl + badge.icon" :alt="badge.name" class="w-10 h-10 object-cover rounded-full" />
            <div>{{ isZh ? badge.name : badge.nameEn }}</div>
          </div>
        </div>

        <div
          class="grid gap-0 border-b border-gray-100 py-2 text-xs text-gray-700"
          :style="{ gridTemplateColumns: `1fr repeat(${badges.length}, 1fr)` }">
          <div class="flex items-center text-xs">
            <van-icon name="gold-coin" size="16" color="#fbbf24" class="mr-1" />
            {{ $t("badges.points") }}
          </div>
          <div v-for="(badge, index) in badges" :key="'points-' + index" class="text-center flex items-center justify-center font-medium">
            {{ badge.point }}
          </div>
        </div>

        <div
          class="grid gap-0 border-b border-gray-100 py-2 text-xs text-gray-700"
          :style="{ gridTemplateColumns: `1fr repeat(${badges.length}, 1fr)` }">
          <div>{{ $t("badges.consumeRM1") }}</div>
          <div v-for="(badge, index) in badges" :key="'consume-' + index" class="text-center font-medium flex items-center justify-center">
            {{ badge.pointTradeGivePoint || "-" }}
          </div>
        </div>

        <div
          class="grid gap-0 border-b border-gray-100 py-2 text-xs text-gray-700"
          :style="{ gridTemplateColumns: `1fr repeat(${badges.length}, 1fr)` }">
          <div>{{ $t("badges.birthdayBenefit") }}</div>
          <div v-for="(badge, index) in badges" :key="'birthday-' + index" class="text-center font-medium flex items-center justify-center">
            {{ badge.birthdayPoint || "-" }}
          </div>
        </div>

        <div
          class="grid gap-0 border-b border-gray-100 py-2 text-xs text-gray-700"
          :style="{ gridTemplateColumns: `1fr repeat(${badges.length}, 1fr)` }">
          <div>{{ $t("badges.exclusiveBenefit") }}</div>
          <div v-for="(badge, index) in badges" :key="'welfare-' + index" class="text-center flex items-center justify-center">
            <img v-if="badge.welfare" :src="rightSrc" alt="right" class="w-5 h-5" />
            <span v-else class="text-gray-300">-</span>
          </div>
        </div>

        <div
          class="grid gap-0 border-b border-gray-100 py-2 text-xs text-gray-700"
          :style="{ gridTemplateColumns: `1fr repeat(${badges.length}, 1fr)` }">
          <div>{{ $t("badges.yoyoCoinValid") }}</div>
          <div v-for="(badge, index) in badges" :key="'pointlong-' + index" class="text-center flex items-center justify-center">
            <img v-if="badge.pointLong" :src="rightSrc" alt="right" class="w-5 h-5" />
            <span v-else class="text-gray-300">-</span>
          </div>
        </div>

        <div
          class="grid gap-0 border-b border-gray-100 py-2 text-xs text-gray-700"
          :style="{ gridTemplateColumns: `1fr repeat(${badges.length}, 1fr)` }">
          <div>{{ $t("badges.freeShipping") }}</div>
          <div v-for="(badge, index) in badges" :key="'postfree-' + index" class="text-center flex items-center justify-center">
            
            <img v-if="badge.postFree" :src="rightSrc" alt="right" class="w-5 h-5" />
            <span v-else class="text-gray-300">-</span>
          </div>
        </div>

        <div class="grid gap-0 py-2 text-xs text-gray-700" :style="{ gridTemplateColumns: `1fr repeat(${badges.length}, 1fr)` }">
          <div>{{ $t("badges.customerService") }}</div>
          <div v-for="(badge, index) in badges" :key="'service-' + index" class="text-center font-medium">
            {{ isZh ? badge.kfSer : badge.kfSerEn }}
          </div>
        </div>
      </div>
    </div> -->

    <div class="mt-7 w-full overflow-hidden mb-6 text-xs">
      <table class="w-full rounded-xl overflow-hidden shadow-sm" style="table-layout: fixed">
        <thead class="bg-gray-100">
          <tr class="">
            <th class="px-1 py-2 font-bold text-gray-800 md:text-xs text-[11px] w-20%" style="vertical-align: bottom">
              {{ $t("badges.benefit") }}
            </th>
            <th
              style="vertical-align: bottom"
              v-for="(badge, index) in badges"
              :key="'table-' + index"
              class="px-1 py-2 font-bold text-gray-800 md:text-xs text-[11px] w-20%">
              <div style="text-align: center">
                <img :src="imageBaseUrl + badge.icon" :alt="badge.name" class="w-10 h-10 object-cover rounded-full mx-auto" />
                <div>{{ isZh ? badge.name : badge.nameEn }}</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <!-- 积分 -->
          <tr class="text-center border-b border-gray-100">
            <td class="px-1">
              <img :src="YoyoCoinsSrc" alt="Yoyo Coins" class="w-4 h-4 inline-block" />
              {{ $t("badges.points") }}
            </td>
            <td v-for="(badge, index) in badges" :key="'points-' + index" class="px-1 py-4 text-xs text-gray-800 text-center">
              <div class="">{{ badge.point }}</div>
            </td>
          </tr>
          <!-- 消费RM1可获得 -->
          <tr class="text-center border-b border-gray-100">
            <td class="px-1">
              <div>{{ $t("badges.consumeRM1") }}</div>
            </td>
            <td v-for="(badge, index) in badges" :key="'consume-' + index" class="px-1 py-4 text-xs text-gray-800 text-center">
              <div class="">{{ badge.pointTradeGivePoint || "-" }}</div>
            </td>
          </tr>
          <!-- 生日福利 -->
          <tr class="text-center border-b border-gray-100">
            <td class="px-1">
              <div>{{ $t("badges.birthdayBenefit") }}</div>
            </td>
            <td v-for="(badge, index) in badges" :key="'birthday-' + index" class="px-1 py-4 text-xs text-gray-800 text-center">
              <div class="">{{ badge.birthdayPoint || "-" }}</div>
            </td>
          </tr>
          <!-- 专属福利 -->
          <tr class="text-center border-b border-gray-100">
            <td class="px-1">
              <div>{{ $t("badges.exclusiveBenefit") }}</div>
            </td>
            <td v-for="(badge, index) in badges" :key="'welfare-' + index" class="px-1 py-4 text-xs text-gray-800 text-center">
              <img v-if="badge.welfare" :src="rightSrc" alt="right" class="w-5 h-5 inline-block" />
              <span v-else class="text-gray-300">-</span>
            </td>
          </tr>
          <!-- Yoyo币永久有效 -->
          <tr class="text-center border-b border-gray-100">
            <td class="px-1">
              <div>{{ $t("badges.yoyoCoinValid") }}</div>
            </td>
            <td v-for="(badge, index) in badges" :key="'pointLong-' + index" class="px-1 py-4 text-xs text-gray-800 text-center">
              <img v-if="badge.pointLong" :src="rightSrc" alt="right" class="w-5 h-5 inline-block" />
              <span v-else class="text-gray-300">-</span>
            </td>
          </tr>
          <!-- 无门槛包邮 -->
          <tr class="text-center border-b border-gray-100">
            <td class="px-1">
              <div>{{ $t("badges.freeShipping") }}</div>
            </td>
            <td v-for="(badge, index) in badges" :key="'postFree-' + index" class="px-1 py-4 text-xs text-gray-800 text-center">
              <img v-if="badge.postFree" :src="rightSrc" alt="right" class="w-5 h-5 inline-block" />
              <span v-else class="text-gray-300">-</span>
            </td>
          </tr>
          <!-- 客服服务 -->
          <tr class="text-center border-b border-gray-100">
            <td class="px-1">
              <div>{{ $t("badges.customerService") }}</div>
            </td>
            <td v-for="(badge, index) in badges" :key="'postFree-' + index" class="px-1 py-4 text-xs text-gray-800 text-center">
              {{ isZh ? badge.kfSer : badge.kfSerEn }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Icon, Progress } from "vant"
import { getLevelList } from "@/apis/mine"
import { mapGetters } from "vuex"

export default {
  name: "MyBadges",
  components: {
    [Icon.name]: Icon,
    [Progress.name]: Progress,
  },
  data() {
    return {
      badges: [],
      rightSrc: require("@/assets/images/right.png"),
      YoyoCoinsSrc: require("@/assets/images/yoyo.png"),
      cur: {},
      next: {},
      diffPoint: 0,
      curPoint: 0,
    }
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
    }),
    imageBaseUrl() {
      return process.env.VUE_APP_IMAGE_URL
    },
  },
  methods: {
    async getBadgeList() {
      try {
        const res = await getLevelList()
        console.log("徽章等级列表:", res)
        this.badges = res.data.levelList || []
        this.cur = res.data.cur || {}
        this.next = res.data.next || {}
        this.diffPoint = res.data.diffPoint || 0
        this.curPoint = res.data.curPoint || 0
      } catch (error) {
        console.error("获取徽章等级列表失败:", error)
      }
    },
  },
  created() {
    this.getBadgeList()
  },
}
</script>

<style scoped>
/deep/ .van-sticky {
  width: 100%;
}

@media (width >= 40rem) {
  :deep(.van-sticky) {
    max-width: 40rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}

@media (width >= 48rem) {
  :deep(.van-sticky) {
    max-width: 48rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}

@media (width >= 64rem) {
  :deep(.van-sticky) {
    max-width: 64rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}

@media (width >= 80rem) {
  :deep(.van-sticky) {
    max-width: 80rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}

@media (width >= 96rem) {
  :deep(.van-sticky) {
    max-width: 96rem;
    margin-inline: auto;
    padding: 0 1rem;
  }
}
</style>
